/**
 * Alert card
 */
import { useEffect } from 'react';
import { ILimitOrder, IPriceAlert } from '@kattana-io/common';
import Text from '../../../atoms/Text';
import Image from '../../../atoms/Image';
import flash from '../../../assets/images/flash.svg';
import close from '../../../assets/images/close--orange.svg';

const DELAY = 7000;

interface IAlertCardProps {
  alert: IPriceAlert | ILimitOrder;
  label: string;
  consumeAlert(): void;
}

const AlertCard = ({ alert, label, consumeAlert }: IAlertCardProps) => {
  const price = alert.price_usd ? `$ ${alert.price_usd}` : alert.price; // decide if usd or relative price
  const [base, quote] = alert.name.split('/');

  useEffect(() => {
    const timer = window.setTimeout(() => {
      consumeAlert();
    }, DELAY);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div className='alert_card'>
      <div className='alert_card__caption'>
        <div className='row'>
          <Text size={14} className='text--orange-400'>
            {label}
          </Text>
          <div className='close'>
            <Image src={close} size='m' onClick={consumeAlert} />
          </div>
        </div>
        <Text size={12} className='mt-4 text--orange-700'>
          {alert.exchange} <Image size='s' src={flash} />
        </Text>
        <div className='row'>
          <Text size={14} className='text--orange-200'>
            {alert.flipped ? `${quote}/${base}` : `${base}/${quote}`}
          </Text>
          <Text size={14} className='text--orange-200'>
            {alert.gt ? '>' : '<'} {price}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default AlertCard;
